import { CommandsManager } from '../../classes';
import { ExtensionManager } from '../../extensions';
import { PubSubService } from '../_shared/pubSubServiceInterface';
import { Button, EvaluateFunction } from './types';
import ServicesManager from '../ServicesManager';

const EVENTS = {
  EXPAND_STUDY: 'event::consultationService:expandStudy',
  STUDY_EXPANDED: 'event::consultationService:studyExpanded',
};

export default class ConsultationService extends PubSubService {
  public static REGISTRATION = {
    name: 'consultationService',
    // Note the old name is ToolBarService, with an upper B
    altName: 'ConsultationService',
    create: ({ commandsManager, extensionManager, servicesManager }) => {
      return new ConsultationService(
        commandsManager,
        extensionManager,
        servicesManager
      );
    },
  };

  state: {
    buttons: Record<string, Button>;
    buttonSections: Record<string, string[]>;
  } = {
    buttons: {},
    buttonSections: {},
  };

  _commandsManager: CommandsManager;
  _extensionManager: ExtensionManager;
  _servicesManager: ServicesManager;
  _evaluateFunction: Record<string, EvaluateFunction> = {};
  _serviceSubscriptions = [];
  // EVENTS = EVENTS;

  constructor(
    commandsManager: CommandsManager,
    extensionManager: ExtensionManager,
    servicesManager: ServicesManager
  ) {
    super(EVENTS);
    this._commandsManager = commandsManager;
    this._extensionManager = extensionManager;
    this._servicesManager = servicesManager;
  }

  public expandStudy(studyInstanceUid, study) {
    this._broadcastEvent(this.EVENTS.EXPAND_STUDY, {
      studyInstanceUid,
      study,
    });
  }

  public studyExpanded(studyInstanceUid, study) {
    this._broadcastEvent(this.EVENTS.STUDY_EXPANDED, {
      studyInstanceUid,
      study,
    });
  }
}
